import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as fromShared from '../../shared';
import * as fromDataServices from '../../data-services';
import moment from 'moment';
import { IUserInfo } from '../../user-info';

@Component({
    selector: 'ef-employee-validation-presenter',
    templateUrl: './employee-validation-presenter.component.html',
    styleUrls: ['./employee-validation-presenter.component.scss'],
    standalone: false
})
export class EmployeeValidationPresenter extends fromShared.EditGrid<fromDataServices.EmployeeValidation.EmployeeValidationModel> {
    @Input()
    employees: fromDataServices.EmployeeValidation.EmployeeValidationModel[];
    @Input()
    paycodes: fromDataServices.PayrollValidation.PayrollValidationModel[];
    @Input()
    lastSyncLists: Date;
    public get validSyncLists() {
        return this.lastSyncLists > new Date(1970, 1, 1);
    }
    @Input()
    lastValidationRun: Date;
    public get validLastValidation() {
        return this.lastValidationRun > new Date(1970, 1, 1);
    }
    @Input()
    validationCompleteDate: Date;
    public get IsValidationComplete() {
        return this.validationCompleteDate > new Date(0);
    }
    @Input()
    nameOrder: string;
    @Input()
    loading: boolean;
    @Input()
    disabled: boolean;
    @Input()
    userInfo: IUserInfo;
    @Output()
    Validate: EventEmitter<unknown> = new EventEmitter();
    @Output()
    Complete: EventEmitter<unknown> = new EventEmitter();
    numCols = 9;
    public moment;
    employeecols = [
        { field: 'EmployeeName', header: 'EmployeeName' },
        { field: 'FirstName', header: 'First Name' },
        { field: 'MiddleName', header: 'Middle Name' },
        { field: 'LastName', header: 'Last Name' },
        { field: 'source', header: 'Source' }
    ];
    payrollcols = [
        { field: 'Title', header: 'Title' },
        { field: 'Type', header: 'Type' },
        { field: 'PayCode', header: 'PayCode' },
        { field: 'source', header: 'Source' }
    ];
    constructor() {
        super();
        this.moment = moment;
    }
    public IsAdmin(): boolean {
        return this.userInfo?.EUserID?.toLocaleLowerCase() === 'admin';
    }
}
